import { inject, Injectable } from '@angular/core';
import { HttpService } from '@utils/http.service';
import { UtilsService } from '@utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpService);
  private utils = inject(UtilsService);

  public roles = async () => await this.http.get(`/v1/catalog/users/roles`).then((response: any) => response.data.content);

  public getList = async () => await this.http.get(`/v1/users`).then((response: any) => this.utils.orderArrayBy(response.data.content, 'firstName'));

  public getParentUserList = async (userId: number) => await this.http.get(`/v1/users/${userId}/parent`).then((response: any) => this.utils.orderArrayBy(response.data.content, 'firstName'));

  public getUsersOfUser = async (userId: number) => await this.http.get(`/v1/users/${userId}/users`).then((response: any) => response.data.content);

  public getByUsername = async (username: string) => await this.http.get(`/v1/users/${username}?by=username`).then((response: any) => response.data);

  public create = async (body: any) => await this.http.post(`/v1/users`, body).then((response: any) => response.data);

  public save = async (username: string, body: any) => await this.http.put(`/v1/users/${username}?by=username`, body).then((response: any) => response.data);

  public delete = async (username: string) => await this.http.delete(`/v1/users/${username}?by=username`).then((response: any) => response.data);

  public changeStatus = async (userId: number, status: string) => await this.http.patch(`/v1/users/${userId}/status`, { status }).then((response: any) => response.data);

  public getSessionsList = async (userId: number) => await this.http.get(`/v1/users/session/list/${userId}`).then((response: any) => response.data);

  public closeSession = async (body: any) => await this.http.post(`/v1/users/session/close`, body).then((response: any) => response.data);

  public disableModuleUser = async (body: any) => await this.http.post(`/v1/users/disable-modules`, body).then((response: any) => response.data);

  public listPricingGroup = async () => await this.http.get(`/v1/users/pricing-group`).then((response: any) => response.data);
  public createPricingGroup = async (body: any) => await this.http.post(`/v1/users/pricing-group`, body).then((response: any) => response.data);
  public getPricingGroup = async (id: number) => await this.http.get(`/v1/users/pricing-group/${id}`).then((response: any) => response.data);
  public updatePricingGroup = async (id: number, body: any) => await this.http.put(`/v1/users/pricing-group/${id}`, body).then((response: any) => response.data);
  public deletePricingGroup = async (id: number) => await this.http.delete(`/v1/users/pricing-group/${id}`).then((response: any) => response.data);

  public listBankGroup = async () => await this.http.get(`/v1/users/bank-group`).then((response: any) => response.data);
  public createBankGroup = async (body: any) => await this.http.post(`/v1/users/bank-group`, body).then((response: any) => response.data);
  public getBankGroup = async (id: number) => await this.http.get(`/v1/users/bank-group/${id}`).then((response: any) => response.data);
  public updateBankGroup = async (id: number, body: any) => await this.http.put(`/v1/users/bank-group/${id}`, body).then((response: any) => response.data);
  public deleteBankGroup = async (id: number) => await this.http.delete(`/v1/users/bank-group/${id}`).then((response: any) => response.data);

  public obtainShareLimit = async (id: number) => await this.http.get(`/v1/users/obtain-share-limit/${id}`).then((response: any) => response.data);
}
